"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMetaDataObj = exports.updateLSCache = exports.getPrefixedFromLS = exports.getPrefixedMetaKey = exports.getPrefixedKey = exports.lsHasKey = exports.getFromLS = exports.writeToLocalStorage = exports.LS_META_SUFFIX = exports.LS_CACHE_PREFIX = void 0;
const differenceInMilliseconds_1 = require("date-fns/esm/differenceInMilliseconds");
const add_1 = require("date-fns/esm/add");
const fromUnixTime_1 = require("date-fns/esm/fromUnixTime");
const getUnixTime_1 = require("date-fns/esm/getUnixTime");
exports.LS_CACHE_PREFIX = "LSC_";
exports.LS_META_SUFFIX = "_META";
/**
 * Writes data to local storage.
 * Automatically converts Objects/Arrays to JSON and primitive types to a string
 * @param key LocalStorage key
 * @param data Data to be written
 * @returns Weather the key existed / was populated beforehand
 */
exports.writeToLocalStorage = (key, data) => {
    const d = typeof data === "string" ? data : JSON.stringify(data);
    const keyPresent = exports.lsHasKey(key);
    localStorage.setItem(key, d);
    return keyPresent;
};
exports.getFromLS = (key) => localStorage.getItem(key);
exports.lsHasKey = (key) => !!localStorage.getItem(key);
exports.getPrefixedKey = (key) => exports.LS_CACHE_PREFIX + key;
exports.getPrefixedMetaKey = (key) => exports.LS_CACHE_PREFIX + key + exports.LS_META_SUFFIX;
/**
 * Prefixes the given key with the default LS_CACHE prefix and returns its value from local storage (or null)
 * @param key to be prefixed and be fetched from LS
 */
exports.getPrefixedFromLS = (key) => localStorage.getItem(exports.getPrefixedKey(key));
exports.updateLSCache = (key, aliveFor, update) => __awaiter(void 0, void 0, void 0, function* () {
    const mainKey = exports.getPrefixedKey(key);
    const metaKey = exports.getPrefixedMetaKey(key);
    // Key doesnt exist yet
    if (!exports.lsHasKey(mainKey)) {
        // Write the key to LS with data from update()
        let data;
        try {
            data = yield update();
        }
        catch (e) {
            console.warn("LS-Cache Update Failed:", e.message);
        }
        if (!data)
            throw new Error(`Update data for LS_KEY=${key} is null`);
        exports.writeToLocalStorage(mainKey, data);
        // Write meta data
        exports.writeToLocalStorage(metaKey, exports.getMetaDataObj(aliveFor));
        return false;
    }
    // Key exists:
    // Check if Meta key exists
    if (!exports.lsHasKey(metaKey))
        throw `Meta key "${metaKey}" not present in Local Storage"`;
    const meta = exports.getFromLS(metaKey);
    let parsedMeta;
    try {
        parsedMeta = JSON.parse(meta);
    }
    catch (e) {
        throw "Error while parsing meta data: " + e.message;
    }
    if (differenceInMilliseconds_1.default(new Date(), add_1.default(fromUnixTime_1.default(parsedMeta.updatedAt), parsedMeta.aliveFor)) > 0) {
        let data;
        try {
            data = yield update();
        }
        catch (e) {
            console.warn("LS-Cache Update Failed:", e.message);
        }
        exports.writeToLocalStorage(mainKey, data);
        exports.writeToLocalStorage(metaKey, exports.getMetaDataObj(parsedMeta.aliveFor));
    }
    return true;
});
exports.getMetaDataObj = (duration) => ({
    aliveFor: duration,
    updatedAt: getUnixTime_1.default(new Date())
});
